import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';
import type {
  HighlightedSeriesIds,
  InteractionState,
  SelectState,
} from '../types.js';

export function reduceExplorePosition<T extends InteractionState>(
  position: RelativeAbsolutePosition,
) {
  return (prev: T): T => ({
    ...prev,
    explore: {
      ...prev.explore,
      visible: true,
      position,
    },
  });
}

export function reduceExploreEnd<T extends InteractionState>(prev: T): T {
  return {
    ...prev,
    explore: {
      ...prev.explore,
      position: prev.explore.pinned ? prev.explore.position : undefined,
      visible: prev.explore.pinned,
    },
  };
}

export function reduceExploreReset<T extends InteractionState>(prev: T): T {
  return {
    ...prev,
    highlightedSeriesIds: undefined,
    explore: {
      ...prev.explore,
      visible: false,
      pinned: false,
      position: undefined,
    },
    select: undefined,
  };
}

export function reduceExplorePin<T extends InteractionState>(
  position: RelativeAbsolutePosition | undefined,
  highlightedSeriesIds?: HighlightedSeriesIds,
) {
  return (prev: T): T => ({
    ...prev,
    highlightedSeriesIds,
    explore: {
      ...prev.explore,
      pinned: true,
      position,
    },
  });
}

export function reduceExploreUnPin<T extends InteractionState>(
  position: RelativeAbsolutePosition | undefined,
) {
  return (prev: T): T => ({
    ...prev,
    select: undefined,
    highlightedSeriesIds: undefined,
    explore: {
      ...prev.explore,
      pinned: false,
      position,
    },
  });
}

export function reduceExploreSelect<T extends InteractionState>(
  select: Partial<SelectState>,
) {
  return (prev: T): T => ({
    ...prev,
    select: {
      ...prev.select,
      ...select,
    },
    explore: {
      visible: false,
      pinned: false,
    },
    highlightedSeriesIds: undefined,
  });
}

export function reduceExploreCancelTooltip<T extends InteractionState>(
  prev: T,
): T {
  return {
    ...prev,
    explore: {
      visible: false,
      pinned: false,
    },
    highlightedSeriesIds: undefined,
  };
}

export function reduceExploreCancelSelect<T extends InteractionState>(
  prev: T,
): T {
  return {
    ...prev,
    select: undefined,
  };
}

export function reduceExploreCancelAll<T extends InteractionState>(prev: T): T {
  return {
    ...prev,
    explore: {
      visible: false,
      pinned: false,
    },
    select: undefined,
    highlightedSeriesIds: undefined,
  };
}
